<template>
  <div id="app">
    <unsaved_changes_alert/>
    <router-view :key="$route.fullPath" />
  </div>
</template>

<script>
import I18n from 'code/i18n'

export default {
  created (){
    window.app=this
    window.app_v= "20200408"
    window.I18n = I18n
    if (process.env.RAILS_ENV === 'production') window.I18n.missingBehaviour="guess"
    window.I18n.default_locale = "en"
    if(window.locale){
      window.I18n.locale = document.documentElement.lang
    }

    this.loadTranslations()
    this.$store.dispatch('login')
  },
}
</script>

<style scoped>
p {
  font-size: 2em;
  text-align: center;
}
</style>
